import { ReactNode } from "react";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AppError } from "@/api/client";

let toastErrorHandler: ((error: AppError) => void) | null = null;

export function setQueryErrorHandler(handler: (error: AppError) => void) {
  toastErrorHandler = handler;
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error: any) => {
      const appError: AppError = error;
      // Show toast for errors unless suppressed
      if (toastErrorHandler && appError?.error && !appError.error.suppressGlobalNotification) {
        toastErrorHandler(appError);
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: (failureCount, error: any) => {
        // Don't retry on 401/403
        if (error?.error?.statusCode === 401 || error?.error?.statusCode === 403) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

type QueryProviderProps = {
  children: ReactNode;
};

export function QueryProvider({ children }: QueryProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
